import MiInnerLoading from './MiInnerLoading.vue'

export default MiInnerLoading
